export const orderProduct = {
  'order-product.continue': 'Continue',
  'order-product.not-available': 'That item is no longer available.',
};
